import { extractUUIDFromLayerId, extractTypeFromLayerId } from "./util"
import { toWgs84 } from "@turf/projection";
import  bbox  from "@turf/bbox";

export const addRoiLayer = (map, roi) => {

  console.log("map in addRoiLayer", map);

  const sourceId = roi.source; 
  const layerId = roi.id;

  if (map.getLayer(layerId)) map.removeLayer(layerId);
  if (map.getSource(sourceId)) map.removeSource(sourceId);

  if (!map.getSource(sourceId)) {
    map.addSource(sourceId, {
      "type": "geojson",
      'data': toWgs84(roi.boundary)
    });
  };
  map.addLayer({
    'id': layerId,
    'type': 'fill',
    'source': sourceId,
    'layout': {
      'visibility': 'visible'
    },
    'paint': {
      'fill-color': roi.color,
      'fill-opacity': 0.8,
      'fill-outline-color': "#FF0000"
    }
  }, "gl-draw-line.cold");
  
  return {
    id: layerId,
    sourceId: sourceId,
    assetType: extractTypeFromLayerId(layerId),
    title: `#${extractUUIDFromLayerId(layerId).slice(0,5)}`,
    bounds: bbox(toWgs84(roi.boundary)), 
    color: roi.color,
    boundary: roi.boundary,
    fgbSrc: roi.fgbSrc
  }
}


